// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1JF0s","image":"Header_image__28WMO","name":"Header_name__37xVR","info":"Header_info__ICjwB","infoRow":"Header_infoRow__1Zp_H"};